<template>
    <icon-base v-bind="$props">
        <path d="M9 6l6 6l-6 6"></path>
    </icon-base>
</template>

<script setup>
import IconBase, { iconProps } from './IconBase.vue'

defineProps(iconProps)
</script>
